import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';

import { WithArtifactService } from '@app/assets/common/artifact.service';
import { WithAuditService } from '@app/assets/common/audit.service';
import type { PromptDto } from '@app/assets/prompt/prompt.dto';
import { PROMPT_PATH } from '@app/shared/api/api-route.config';
import { WithExportableService } from '@app/shared/api/export.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithWorkflowableService } from '@app/shared/approval/workflow.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithCrudVersionService } from '@app/shared/change-log/version.service';
import { WithJobService } from '@app/shared/job-history/job.service';
import { WithLineageService } from '@app/shared/lineage/lineage.service';
import { ToastNotificationService } from '@app/shared/notification/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class PromptService extends classes(
    WithCrudVersionService<PromptDto>,
    WithJobService,
    WithAuditService,
    WithArtifactService,
    WithWorkflowableService,
    WithLogService,
    WithExportableService,
    WithLineageService,
) {
    protected endpoint = PROMPT_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
}
